<template>
  <div v-if="show">
    <base-popup :disabled="isLoading" @close="$emit('close')" :media="ressourcesByType(ressourceType)" :minWidth="66">
      <template #header>
        <h3>Sélectionner une ressource</h3>
      </template>
      <template #bodyContent v-if="ressources.filter(e => e.type_ressource == ressourceType).length == 0">
          <span>Aucune ressource trouvée</span>
      </template>
      <template #body="{el, index}">
        <div class="popup-item" :class="{ 'selected': el.path === selectedResourcePath }" @mouseenter="videoPlay(index, 1)" @mouseleave="videoPlay(index, 0)">
          <div class="popup-item-icon">
            <div v-show="loadingImages[index] == true && (ressourceType == 'image' || ressourceType == 'video')" class="image-loader">
              <div class="loader-spinner"></div>
            </div>
            <img v-if="ressourceType == 'image'" :src="el.url" :alt="el.description" @load="onImageLoad(index)"/>
            <div v-else-if="ressourceType == 'video'" class="video-preview">
              <canvas class="video-canvas" :ref="(el) => setVideoCanvasRef(el, index)"></canvas>
              <video class="video-element" :src="el.url" :ref="(el) => setVideoElementRef(el, index)" loop muted @canplay="setVideoCanvas(index)"></video>
            </div>
            <div class="popup-item-actions">
              <div class="popup-item-select" @click="selectRessource(el)">
                <span>Sélectionner</span>
                <validateIcon :style="{width: '25px', height: '25px'}"/>
              </div>
              <div class="popup-item-delete" @click="confirmDelete(el)" v-if="el.canBeDeleted">
                <span>Supprimer</span>
                <deleteIcon :style="{width: '25px', height: '25px'}"/>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <button class="popup-button create" @click="!isLoading && $refs.inputFile.click()" :disabled="isLoading">
          <svg v-if="!isLoading" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
          </svg>
          {{ isLoading ? 'Upload en cours...' : 'Ajouter une ressource' }}
        </button>
        <button class="popup-button cancel" @click="$emit('close')">
          <cancelIcon class="button-icon"/>
          Annuler
        </button>
      </template>
    </base-popup>
    <input type="file" ref="inputFile" style="display: none" :accept="fileAccept" @change="onFileChanged" multiple/>
    <delete-confirm-popup :show="showDeleteConfirmPopup" @close="showDeleteConfirmPopup = false" @confirm="removeRessource(confirmDeleteElement.idSoft)" :elementName="confirmDeleteElement?.name"/>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import * as namespaceStore from "../../vuexStore/namespaceStore.js"
import * as mutations from "../../vuexStore/mutations.js"
import * as actions from "../../vuexStore/actions.js"
import cancelIcon from "../IconComponents/cancelIcon.vue"
import deleteIcon from "../IconComponents/deleteIcon.vue"
import validateIcon from "../IconComponents/validateIcon.vue"
import BasePopup from "./Base/BasePopup.vue"
import DeleteConfirmPopup from "./DeleteConfirmPopup.vue"

export default {
  name: 'ResourceSelectionPopup',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    selectedResourcePath: {
      type: String,
      default: ''
    },
    ressourceType: {
      type: String,
      default: "image"
    }
  },
  components: {
    BasePopup,
    cancelIcon,
    deleteIcon,
    validateIcon,
    DeleteConfirmPopup
  },
  data() {
    return {
      maxSize: {
        width: 1080,
        height: 1920,
      },  
      isLoading: false,
      loadingImages: [],
      showDeleteConfirmPopup: false,
      confirmDeleteElement: null,
      videoCanvas: [],
      videoElement: []
    };
  },
  computed: {
    ...mapGetters(namespaceStore.THEME, [
      "ressources",
      "ressourcesByType"
    ]),
    fileAccept: function() {
      if (this.ressourceType == "image") return "image/*";
      else if (this.ressourceType == "video") return "video/*";
      return "*";
    }
  },
  watch: {
    show: function() {
        if (this.show == false) this.isLoading = false;
        this.loadingImages = [];
        this.ressources.forEach((res, index) => {
            this.loadingImages[index] = true;
        })
    }
  },
  emits: ['close', 'select', 'add'],
  methods: {
    ...mapActions(namespaceStore.THEME, {
      'actionRemoveRessource': actions.REMOVE_RESSOURCE,
      'uploadRessource': actions.UPLOAD_RESSOURCE
    }),
    ...mapActions(namespaceStore.MESSAGE, [
      "addMessage"
    ]),
    setVideoCanvasRef(element, index) {
      this.videoCanvas[index] = element;
    },
    setVideoElementRef(element, index) {
      this.videoElement[index] = element;
    },
    removeRessource(idSoft) {
      this.actionRemoveRessource({clear: true, idSoft: idSoft}).finally(() => {
        this.showDeleteConfirmPopup = false;
        this.confirmDeleteElement = null;
      });
    },
    confirmDelete(element) {
      this.showDeleteConfirmPopup = true;
      this.confirmDeleteElement = element;
    },
    onImageLoad(index) {
        this.loadingImages[index] = false;
    },
    setVideoCanvas(index) {
      const maxSize = {
        width: 150,
        height: 150
      };
      if (this.videoElement[index].videoWidth > this.videoElement[index].videoHeight) {
        maxSize.height = 150 * (this.videoElement[index].videoHeight / this.videoElement[index].videoWidth);
      }
      else {
        maxSize.width = 150 * (this.videoElement[index].videoWidth / this.videoElement[index].videoHeight);
      }
      this.loadingImages[index] = false;
      this.videoCanvas[index].width = maxSize.width;
      this.videoCanvas[index].height = maxSize.height;
      this.videoCanvas[index].getContext('2d').drawImage(this.videoElement[index], 0, 0, maxSize.width, maxSize.height);
    },
    videoPlay(index, play) {
      if (this.ressourceType != 'video') return;
      if (play) {
        this.videoElement[index].play();
      }
      else {
        this.videoElement[index].pause();
        this.videoElement[index].currentTime = 0;
      }
    },
    onFileChanged: function(event) {
      const files = this.$refs.inputFile.files;
      
      if (files && files.length) {
        this.isLoading = true;
        for (var i=0, l=files.length; i<l; i++) {
            let fileReader = new FileReader();
            fileReader.originalFile = files[i];
            fileReader.onload = this.createImageFromFile;
            fileReader.readAsDataURL(fileReader.originalFile);
        }
      }
    },
    selectRessource: function(ressource) {
      if (!this.isLoading) {
        this.$emit('select', ressource);
        this.$emit('close');
      }
    },
    createImageFromFile: function(ev) {
      const file = ev.target.originalFile;
      // Validation du fichier
      if (!file) {
        throw new Error('Aucun fichier sélectionné');
      }
      // Vérifier la taille du fichier (25MB max)
      const maxSize = 25 * 1024 * 1024; // 25MB
      if (file.size > maxSize) {
        this.addMessage({
          message: 'Le fichier est trop volumineux. Taille maximale: 5MB',
          type: 'error'
        });
        this.isLoading = false;
        return;
      }
      // Déterminer le type de ressource basé sur le type MIME et l'extension
      let typeRessource = this.determineResourceType(file);
      // Vérifier que le type correspond au type attendu par le popup
      if (this.ressourceType !== 'image' && typeRessource !== this.ressourceType) {
        throw new Error(`Type de fichier non supporté. Attendu: ${this.ressourceType}, Reçu: ${typeRessource}`);
      }
      // Créer le FormData pour l'upload
      const formData = new FormData();
      formData.append('fichier', file);
      formData.append('nom', file.name);
      formData.append('description', `Fichier uploadé: ${file.name}`);
      formData.append('type_ressource', typeRessource);
      // Upload du fichier au serveur
      this.uploadRessource(formData).then(response => {
          // Émettre un événement pour informer le parent
          this.$emit('add', response.ressource);
      }).finally(() => {
        // Réinitialiser l'input file
        if (this.$refs.inputFile) {
          this.$refs.inputFile.value = '';
        }
        // Marquer comme non chargé
        this.isLoading = false;
      });
    },
    determineResourceType: function(file) {
      // Déterminer le type de ressource basé sur le type MIME et l'extension
      const extension = file.name.split('.').pop().toLowerCase();
      
      // Vérifier d'abord le type MIME
      if (file.type.startsWith('image/')) {
        return 'image';
      } else if (file.type.startsWith('video/')) {
        return 'video';
      } else if (file.type.includes('font') || file.type.includes('woff') || file.type.includes('ttf')) {
        return 'font';
      }
      // Si le type MIME n'est pas clair, vérifier l'extension
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'];
      const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv'];
      const fontExtensions = ['ttf', 'otf', 'woff', 'woff2'];
      
      if (imageExtensions.includes(extension)) {
        return 'image';
      } else if (videoExtensions.includes(extension)) {
        return 'video';
      } else if (fontExtensions.includes(extension)) {
        return 'font';
      }
      
      // Par défaut, considérer comme image
      return 'image';
    },
  }
}
</script>

<style scoped>
.video-preview {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-item:hover .video-element {
  display: block;
}
.popup-item:hover .video-canvas {
  display: none;
}

.video-preview .video-element {
  display: none;
}
.video-preview .video-canvas {
  max-width: 100%;
  max-height: 100%;
}

.popup-item-actions {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  opacity: 0;
  pointer-events: none;
  transition: all 0.2s ease;
}

.popup-item-select {
  background-color: rgba(0, 255, 0, 0.25);
  flex: 2;
}
.popup-item-select:hover {
  background-color: rgba(0, 255, 0, 0.4); 
}

.popup-item-delete {
  background-color: rgba(255, 0, 0, 0.25);
  flex: 1;
}
.popup-item-delete:hover {
  background-color: rgba(255, 0, 0, 0.4);
}

.popup-item-select, .popup-item-delete {
  color: white;
  padding: 0.5rem;
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  text-shadow: 1px 1px 2px black;
  filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7));
}

.popup-item:hover .popup-item-actions {
  opacity: 1;
  pointer-events: auto;
}

.popup-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background-color: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.popup-item-icon {
  width: 150px;
  height: 150px;
  background-color: rgba(255, 255, 255, 0.1);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-item-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.popup-item-icon video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.image-loader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.loader-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid rgba(59, 130, 246, 0.3);
  border-radius: 50%;
  border-top-color: #3b82f6;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.popup-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.popup-button.cancel {
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #e5e7eb;
}

.popup-button.cancel:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.popup-button.validate {
  background-color: rgba(59, 130, 246, 0.2);
  border: 1px solid rgba(59, 130, 246, 0.3);
  color: #3b82f6;
}

.popup-button.validate:hover:not(:disabled) {
  background-color: rgba(59, 130, 246, 0.3);
  border-color: #3b82f6;
}

.popup-button.validate:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.button-icon {
  width: 1rem;
  height: 1rem;
}

.popup-button.create {
  background-color: rgba(16, 185, 129, 0.2);
  border: 1px solid rgba(16, 185, 129, 0.3);
  color: #10b981;
}

.popup-button.create:hover {
  background-color: rgba(16, 185, 129, 0.3);
  border-color: #10b981;
}

</style> 